// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDatastanderOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDatastanderOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDatastanderOutlined = function DrrpDatastanderOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDatastanderOutlinedSvg
  }));
};

DrrpDatastanderOutlined.displayName = 'DrrpDatastanderOutlined';
export default React.forwardRef(DrrpDatastanderOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDatastanderOutlined.js
// module id = 2554
// module chunks = 0